<aside class="main-sidebar">
  <section class="sidebar">
    <div class="mob_logo">
      <a [routerLink]="['/waitinglist']"
        ><img src="assets/images/logo.png" alt=""
      /></a>
    </div>
    <ul class="sidebar-menu" data-widget="tree">

      <li class="treeview"
      *ngIf="validateSideMenuVisibility('administration')"
      [ngClass]="mybusiness ? 'active' : ''">
        <a (click)="menuopen('mybusiness')" style="color: #adb5bd; cursor: pointer">
          <i class="fa fa-truck"></i><span>Home</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu" *ngIf="mybusiness">
          <li *ngIf="validateSideMenuVisibility('userControls')">
            <a [routerLink]="['/dashboard/user-mngnt']" routerLinkActive="active"
              ><i class="fa fa-user"></i>User controls</a
            >
          </li>

          <li *ngIf="validateSideMenuVisibility('dashboard')">
            <a [routerLink]="['/dashboard/dashboard-mngnt']" routerLinkActive="active"
              ><i class="fa fa-dashboard"></i>Dashboard</a
            >
          </li>
          <li *ngIf="validateSideMenuVisibility('details-dashboard')">
            <a [routerLink]="['/details-dashboard']" routerLinkActive="active"
              ><i class="fa fa-search"></i>BOL Search</a
            >
          </li>
          <li *ngIf="validateSideMenuVisibility('paper-work')">
            <a [routerLink]="['dashboard/paper-work']" routerLinkActive="active"
              ><i class="fa fa-file"></i>Paperwork</a
            >
          </li>
          <li *ngIf="validateSideMenuVisibility('take-order')">
            <a [routerLink]="['/take-order']" routerLinkActive="active"
              ><i class="fa fa-shopping-cart"></i>Take Order
              <div class="coming-soon">Coming soon</div>
              </a
            >
          </li>
          <li *ngIf="validateSideMenuVisibility('tank-inventory')">
            <a [routerLink]="['/tank-inventory']" routerLinkActive="active"
              ><i class="fa fa-shopping-cart"></i>Inventory
              <div class="coming-soon">Coming soon</div>
              </a
            >
          </li>

          <li *ngIf="validateSideMenuVisibility('heapStatus')">
            <a [routerLink]="['/dashboard/graph']" routerLinkActive="active"
              ><i class="fa fa-server"></i>Heap status</a
            >
          </li>

          <li *ngIf="validateSideMenuVisibility('mapHistory')">
            <a [routerLink]="['/googlemaps/path-history']" routerLinkActive="active"
              ><i class="fas fa-route"></i> Path History</a
            >
          </li>

          <li *ngIf="validateSideMenuVisibility('fleetStatus')">
            <a [routerLink]="['/googlemaps/fleet-status']" routerLinkActive="active">
              <i class="fa fa-map-marker"></i>Fleet status
            </a>
          </li>

          <li *ngIf="validateSideMenuVisibility('deviceControls')">
            <a [routerLink]="['/device']" routerLinkActive="active"
              ><i class="fa fa-laptop"></i>Device Controls</a
            >
          </li>
           <li *ngIf="validateSideMenuVisibility('tenantDeviceControls')">
            <a [routerLink]="['/device/tenant-device']" routerLinkActive="active"
              ><i class="fa fa-laptop"></i>Device Approvals</a
            >
          </li>
          <li *ngIf="validateSideMenuVisibility('tenantActivity')">
            <a [routerLink]="['/tenant']" routerLinkActive="active"
              ><i class="fa fa-database"></i>Tenant Activity</a
            >
          </li>
          <li *ngIf="validateSideMenuVisibility('accessControl')">
            <a [routerLink]="['/access-control']" routerLinkActive="active"
              ><i class="fa fa-wrench"></i>Access Control</a
            >
          </li>
          <li *ngIf="validateSideMenuVisibility('user-security')">
            <a [routerLink]="['/user-security']" routerLinkActive="active"
              ><i class="fa fa-wrench"></i>User Security</a
            >
          </li>
          <li *ngIf="validateSideMenuVisibility('user-access')">
            <a [routerLink]="['/user-access']" routerLinkActive="active"
              ><i class="fa fa-cog"></i>User Access</a
            >
          </li>
          <li *ngIf="validateSideMenuVisibility('errorControls')">
            <a [routerLink]="['/error-control']" routerLinkActive="active"
              ><i class="fa fa-exclamation-triangle"></i>Error Control</a
            >
          </li>
          <li *ngIf="validateSideMenuVisibility('resendFiles')">
            <a [routerLink]="['/ftp-checks']" routerLinkActive="active"
              ><i class="fa fa-upload"></i>Ftp Controls & File Resend</a
            >
          </li>
          <li *ngIf="validateSideMenuVisibility('load-details')">
            <a [routerLink]="['/load-details']" routerLinkActive="active"
              ><i class="fas fa-truck-loading"></i>Load Details</a
            >
          </li>
          <!-- <li *ngIf="validateSideMenuVisibility('wait-time-out')">
            <a [routerLink]="['/wait-time-out']" routerLinkActive="active"
              ><i class="fas fa-truck-loading"></i>Wait Timeout</a
            >
          </li> -->
          <li *ngIf="validateSideMenuVisibility('emergency-bol')">
            <a [routerLink]="['/emergency-bol']" routerLinkActive="active"
              ><i class="fas fa-shipping-fast fa-yellow"></i> Online Dispatch</a
            >
          </li>
          <!-- <li *ngIf="validateSideMenuVisibility('driver-route-sheet')">
            <a [routerLink]="['/driver-route-sheet']" routerLinkActive="active"
              ><i class="fas fa-truck-loading"></i>Tenant Routes</a
            >
          </li> -->
          <li *ngIf="validateSideMenuVisibility('bill-of-lading')">
            <a [routerLink]="['/bill-of-lading']" routerLinkActive="active"
              ><i class="fas fa-truck-loading"></i>Load Troubleshooting</a
            >
          </li>
        </ul>
      </li>

      <li class="treeview" [ngClass]="statitionInventory ? 'active' : ''"
      *ngIf="validateSideMenuVisibility('stationInventory')"
      style="color: #adb5bd; cursor: pointer"
      >
        <a (click)="menuopen('statitioninventory')" style="color: #adb5bd; cursor: pointer">
          <i class="fas fa-gas-pump" title="Role Management"></i
          ><span>Station Inventory</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        <ul class="treeview-menu">
          <li >
            <a [routerLink]="['/dashboard/station-inventory']" routerLinkActive="active"
              ><i class="fa fa-user"></i>Inventory Dashboard</a
            >
          </li>
          <li >
            <a [routerLink]="['/dashboard/inventory-tank-levels']" routerLinkActive="active"
              ><i class="fas fa-gas-pump small-icon"></i>Tank levels</a
            >
          </li>
        </ul>
      </li>

      <li [ngClass]="ceconnectlite ? 'active' : ''"
      *ngIf="displayLite">
        <a href="https://ceconnect.creative123.net" target="_blank">
          <i class="fa fa-phone" title="Role Management"></i
          ><span>Ce Connect Lite</span>
        </a>
      </li>

      <!-- <li class="treeview" [ngClass]="dispatchLite ? 'active' : ''"
      *ngIf="validateSideMenuVisibility('dispatchLite')"
      style="color: #adb5bd; cursor: pointer"
      >
        <a (click)="menuopen('dispatchLite')" style="color: #adb5bd; cursor: pointer">
          <i class="fas fa-gas-pump" title="Role Management"></i
          ><span>Dispatch Lite</span>
          <span class="pull-right-container">
            <i class="fa fa-angle-left pull-right"></i>
          </span>
        </a>
        
      </li> -->



    </ul>
  </section>
</aside>
